/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { AddToolTipOnDisabled, DisableElement } from 'clm-components';
import { isEmpty } from 'lodash';
import { doesHavePermission } from './utils';
import {
  ComponentType, PermissionObjectType, GetUserPermissionsHook,
} from '../../types/Permission';

const PermissionWrapper = (
  Component: ComponentType,
  useGetUserPermissions: GetUserPermissionsHook,
  permissionObject?: PermissionObjectType,
) => function ComponentWrappedWithPermissions({ ...props }) {
  const { allowedPermissions = [], disallowedPermissions = [] } = useGetUserPermissions() || {};
  const {
    requiredPermissions = {}, redirect, tooltipProps = {}, disabledElementProps = {},
  } = permissionObject || {};
  const {
    viewPermissions = [],
    interactPermissions = [],
  } = requiredPermissions;

  if (isEmpty(viewPermissions) && isEmpty(interactPermissions)) {
    return <Component {...props} />;
  }

  const doesHaveViewPermissions = doesHavePermission(
    viewPermissions,
    allowedPermissions,
    disallowedPermissions,
  );

  const doesHaveInteractPermissions = doesHavePermission(
    interactPermissions,
    allowedPermissions,
    disallowedPermissions,
  );

  if (!doesHaveViewPermissions) {
    if (redirect) {
      return redirect();
    }
    return '';
  }

  if (doesHaveViewPermissions && !doesHaveInteractPermissions) {
    return (
      <AddToolTipOnDisabled isDisabled={!isEmpty(tooltipProps)} {...tooltipProps}>
        <DisableElement {...disabledElementProps}>
          <Component {...props} />
        </DisableElement>
      </AddToolTipOnDisabled>
    );
  }

  if (doesHaveViewPermissions && doesHaveInteractPermissions) {
    return <Component {...props} />;
  }

  return '';
};

export default PermissionWrapper;
